import { render, staticRenderFns } from "./JTreeTable.vue?vue&type=template&id=ba3bd2be&scoped=true"
import script from "./JTreeTable.vue?vue&type=script&lang=js"
export * from "./JTreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3bd2be",
  null
  
)

export default component.exports